import { useLocation, Link } from "react-router-dom";
import React, { useState, useEffect } from "react";

const Footer = () => {
  const location = useLocation();
  const baseUrl = location.pathname.split("/")[0];
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Handle responsive behavior
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const locations = [
    { name: "Zimmerman", icon: "location.png" },
    { name: "Githurai 44", icon: "location.png" },
  
  ];

  const socialLinks = [
    {
      name: "Facebook",
      url: "https://www.facebook.com/konnecthub",
      icon: "facebook.png",
    },
    {
      name: "Twitter",
      url: "https://twitter.com/KonnectInternet",
      icon: "twitter.png",
    },
    {
      name: "YouTube",
      url: "https://www.youtube.com/@KaribuKonnect",
      icon: "youtube.png",
    },
    {
      name: "Instagram",
      url: "https://instagram.com/konnecthub",
      icon: "insta.png",
    },
  ];

  const isMobile = windowWidth < 768;

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-locations">
          <div className="locations-wrapper">
            {locations.map((location, index) => (
              <div key={index} className="location-item">
                <img
                  src={`${baseUrl}/images/${location.icon}`}
                  alt={`${location.name} location`}
                  className="location-icon"
                />
                <span>{location.name}</span>
              </div>
            ))}
          </div>
          <div className="footer-tagline">Stay Konnected beyond limits</div>
          <div className="footer-copyright">
            © {new Date().getFullYear()} Ahadi Corporation
          </div>
        </div>

        <div className="footer-bottom">
          <div className="social-section">
            <h3 className="social-heading">Follow Us</h3>
            <div className="social-icons">
              {socialLinks.map((social, index) => (
                <Link
                  key={index}
                  to={social.url}
                  target="_blank"
                  rel="noreferrer"
                  className="social-link"
                  aria-label={`Follow us on ${social.name}`}
                >
                  <img
                    src={`${baseUrl}/images/${social.icon}`}
                    alt={social.name}
                    className="social-icon"
                  />
                </Link>
              ))}
            </div>
          </div>

          <div className="contact-section">
            <h3 className="contact-heading">Contact Us</h3>
            <div className="contact-info">
              <a href="tel:+254701888666" className="contact-link">
                <span className="contact-icon">📞</span> +254 701 888 666
              </a>
              <a href="tel:+254111221188" className="contact-link">
                <span className="contact-icon">📞</span> +254 111 221 188
              </a>
              {isMobile && (
                <a
                  href="https://wa.me/+254111221188"
                  className="contact-link whatsapp-link"
                >
                  <span className="whatsapp-text">WhatsApp Us</span>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
